var render = function render(){var _vm=this,_c=_vm._self._c;return _c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.bannerList),function(item,index){return _c('swiper-slide',{key:index},[_c('img',{staticClass:"img",staticStyle:{"object-fit":"cover"},attrs:{"src":item}})])}),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }